/*
 * Header cart total counts up or down to the new amount, the same ease the trade quote totals use.
 * No other cart animation. Every writer (shelf add, Your Cart, Dawn's section refresh) just sets the
 * new total; this watcher notices the change and rolls the number from the old amount to the new one.
 */
(function () {
  var link = document.getElementById('cart-icon-bubble');
  if (!link) return;
  var shown = null;
  var frame = 0;
  var observer = null;

  function slot() {
    return link.querySelector('.ri-header__cart-total');
  }

  function centsIn(el) {
    if (!el || el.hidden) return null;
    var money = el.querySelector('[data-ri-cents]');
    if (money) return Number(money.getAttribute('data-ri-cents'));
    var text = (el.textContent || '').replace(/,/g, '');
    var m = text.match(/\$\s*(\d+)\.(\d{2})/) || text.match(/\$\s*(\d+)/);
    if (!m) return null;
    return Number(m[1]) * 100 + Number(m[2] || 0);
  }

  function format(cents) {
    if (window.RIMoney && window.RIMoney.formatCents) return window.RIMoney.formatCents(cents, '$');
    return '$' + (cents / 100).toFixed(2);
  }

  function paint(cents) {
    var el = slot();
    if (!el) return;
    el.innerHTML = format(Math.round(cents));
    if (observer) observer.takeRecords();
  }

  function roll(from, to) {
    if (frame) clearTimeout(frame);
    var start = performance.now();
    var dur = 420;
    paint(from);
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var e = 1 - Math.pow(1 - t, 3);
      paint(from + (to - from) * e);
      if (t < 1) frame = window.setTimeout(next, 16);
      else {
        frame = 0;
        paint(to);
      }
    }
    function next() {
      tick(performance.now());
    }
    frame = window.setTimeout(next, 16);
  }

  function onChange() {
    var next = centsIn(slot());
    if (next === null) {
      shown = null;
      return;
    }
    if (shown === null || next === shown) {
      shown = next;
      return;
    }
    var from = shown;
    shown = next;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) roll(from, next);
  }

  shown = centsIn(slot());
  if (window.MutationObserver) {
    observer = new MutationObserver(onChange);
    observer.observe(link, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  }
})();
